<template>
  <footer class="footer">
    <div class="col-12 justify-content-center container-md row">
      <nav class="col-3 col-md-4 ml-md-4">
        <ul class="footer-menu">
          <li>
            <router-link :to="{ path: '/admin' }">Dashboard</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright text-end col-8 col-md-6 ml-md-5 pl-md-3">
        &copy; Desarrollado con
        <i class="fa fa-heart heart"></i> por
        <a href="https://ticktaps.com" target="_blank" class=" font-weight-bold" style="color: black;">Ticktaps</a>.

      </div>
    </div>
  </footer>
</template>
<script>
export default {}

</script>
<style></style>
